// Validación para mostrar el botón de descarga de vouchers
export const shouldShowVoucherButton = (tariffProviderId: string, reference: string): boolean => {
	const validProviders = ['5663cb81-270c-465f-8a0c-322dc2ccd35f', '1f129439-e49a-4707-a9b0-3cb9c2cc53dd'];

	return (
		validProviders.includes(tariffProviderId) &&
		Boolean(reference) &&
		reference.trim() !== '' &&
		reference.trim() !== '-'
	);
};

// Generar el string servicePassengers concatenando name_lastName de los pasajeros
export const generateServicePassengers = (
	passengerIds: string[],
	passengers: Array<{ keyId: string; name: string; lastName: string }>,
): string => {
	return passengerIds
		.map((passengerId) => {
			const passenger = passengers.find((p) => p.keyId === passengerId);
			if (passenger) {
				return `${passenger.name}_${passenger.lastName}`;
			}
			return null;
		})
		.filter(Boolean)
		.join('_');
};

// Obtener el serviceType apropiado para la API de vouchers
export const getServiceTypeForVoucherAPI = (serviceType: string): string => {
	// Mapeo de tipos de servicio internos a los esperados por la API
	const serviceTypeMapping: Record<string, string> = {
		Transfer: 'traslados',
		Flight: 'vuelos',
		Accommodation: 'alojamiento',
		Other: 'otros',
		Fee: 'tarifas',
		FlightAncillary: 'auxiliares',
	};

	return serviceTypeMapping[serviceType] || serviceType.toLowerCase();
};
